export interface RecordingLatencyEstimateInput {
  inputLatencySeconds?: number | null
  baseLatencySeconds?: number | null
  outputLatencySeconds?: number | null
}

export function normalizeLatencyMs(value: number): number {
  if (!Number.isFinite(value)) return 0
  return Math.round(Math.min(500, Math.max(0, value)))
}

/**
 * 브라우저/장치가 제공하는 latency hint를 이용한 초기 추정치입니다.
 * MediaRecorder 내부 버퍼링까지 정확히 측정하는 round-trip calibration은 아니므로
 * 실제 합주 정렬은 Take별 수동 보정으로 미세 조정할 수 있습니다.
 */
export function estimateRecordingLatencyMs(input: RecordingLatencyEstimateInput): number {
  const seconds = [
    input.inputLatencySeconds ?? 0,
    input.baseLatencySeconds ?? 0,
    input.outputLatencySeconds ?? 0,
  ]
    .filter((value) => Number.isFinite(value) && value > 0)
    .reduce((sum, value) => sum + value, 0)

  return normalizeLatencyMs(seconds * 1000)
}
